<template>
  <v-row>
    <v-col class="mt-2" cols="12" lg="10" offset-lg="1">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card>
        <v-card-title class="theme mb-2">
          <v-icon large class="white--text">supervised_user_circle</v-icon>
          <span class="headline ml-2 white--text">Employees</span>
          <v-spacer />
          <v-btn
            @click="openForm"
            depressed
            class="action white--text rounded-sm"
            v-if="!isDemo"
            >Add Employees
          </v-btn>
          <v-btn
            @click="add_entity_dialog2 = true"
            depressed
            class="rounded-sm disabled"
            v-else
            >Add Employees
          </v-btn>
          <!-- <v-btn
            @click="add_entity_dialog2 = true"
            depressed
            class=" rounded-sm disabled"
            v-if="isDemo"
            >Add Employees
          </v-btn>          -->
        </v-card-title>
        <!--start-->
        <v-card-text
          style="margin-top: -0.5rem; margin-bottom: -1rem"
          class="mx-3"
        >
          <v-row class="mt-3 mb-n5 ml-n2 mr-5">
            <v-col cols="12" md="4">
              <v-autocomplete
                label="Status"
                :items="types"
                item-text="name"
                item-value="name"
                v-model="search.type"
                persistent-hint
                clearable
                outlined
                dense
                @change="getEmployees()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                :items="locations"
                dense
                label="Location"
                v-model="search.job_location"
                item-text="name"
                item-value="name"
                clearable
                outlined
                @change="getEmployees()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                :items="departments"
                outlined
                label="Department"
                v-model="search.department"
                dense
                item-text="name"
                item-value="name"
                clearable
                @change="getEmployees()"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <!--end-->
        <v-divider />
        <v-card-text>
          <v-data-table
            v-if="employees"
            :headers="tableHeaders"
            :items="employees"
            class="elevation-0 row-pointer"
            :hide-default-footer="true"
            @click:row="viewEntityDetails"
          >
            <template v-slot:item.profile_image_url="{ item }">
              <v-avatar size="65" class="my-1" v-if="item.profile_image_url">
                <v-img :src="item.profile_image_url" alt="Profile Image" />
              </v-avatar>
              <v-avatar
                size="65"
                dark
                class="grey lighten-2 my-1 display-1"
                :style="{ color: getColorFromName(`${item.id}`) }"
                v-else
              >
                {{ getNameInitials(`${item.first_name} ${item.last_name}`) }}
              </v-avatar>
            </template>
            <template v-slot:item.full_name="{ item }">
              <div
                class="
                  font-weight-bold
                  grey--text
                  text--darken-3
                  subtitle-1
                  text-capitalize
                "
              >
                {{ `${item.first_name} ${item.last_name}` }}
              </div>

              <div class="font-weight-regular mt-n1">
                {{ item.job_title ? item.job_title : "-" }}
              </div>

              <div class="font-weight-regular subtext mt-n1">
                {{ item.work_email ? item.work_email : "-" }}
              </div>
            </template>
            <template v-slot:item.phone_number="{ item }">
              <div v-if="item.phone_num">
                Tel: {{ item.phone_isd }} {{ item.phone_num }}
              </div>
              <div v-else-if="item.work_phone_num">
                Tel: {{ item.work_phone_isd }} {{ item.work_phone_num }}
              </div>
              <div v-else>-</div>
            </template>
            <template v-slot:item.department="{ item }">
              <div>{{ item.department ? item.department : "-" }}</div>
            </template>
            <template v-slot:item.job_location="{ item }">
              <div>{{ item.job_location ? item.job_location : "-" }}</div>
            </template>
            <template v-slot:item.type="{ item }">
              <div>{{ item.type }}</div>
              <div
                v-if="
                  item.type === 'Registered' && !isDefaultDate(item.start_date)
                "
              >
                <div class="font-weight-regular subtext mt-n1">
                  {{ invitationStatus(item) }}
                </div>
                <div class="font-weight-regular subtext mt-n1">
                  Starting job on {{ item.start_date.substring(0, 10) }}
                </div>
              </div>
              <div
                v-else-if="
                  item.type === 'Registered' && isDefaultDate(item.start_date)
                "
              >
                <div class="font-weight-regular subtext mt-n1">
                  {{ invitationStatus(item) }}
                </div>
              </div>
            </template>
            <template v-slot:footer>
              <div class="text-center mt-5">
                <v-btn
                  fab
                  small
                  color="theme white--text"
                  depressed
                  @click="previous"
                  :disabled="pagination.page <= 0"
                >
                  <v-icon small>navigate_before</v-icon>
                </v-btn>
                <span>
                  <v-btn text :disabled="true">{{ pagination.page + 1 }}</v-btn>
                </span>
                <v-btn
                  fab
                  small
                  depressed
                  color="theme white--text"
                  @click="next"
                  :disabled="pagination.disableNext"
                >
                  <v-icon small>navigate_next</v-icon>
                </v-btn>
              </div>
              <!-- </td> -->
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-col>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <template>
      <v-row justify="center">
        <v-dialog v-model="add_entity_dialog2" persistent width="400px">
          <v-card>
            <v-card-title class="theme">
              <span class="headline white--text">You are in demo mode</span>
              <v-spacer />
              <v-btn icon @click="add_entity_dialog2 = false">
                <v-icon class="white--text">close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="mt-3">
              In order to start inviting new employees you'll need to end the
              demo and activate your membership.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                class="save rounded-sm white--text my-2 mx-2"
                @click="add_entity_dialog2 = false"
                small
                depressed
                >OK</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <template>
      <v-row justify="center">
        <v-dialog v-model="add_entity_dialog" persistent width="700px">
          <v-card>
            <v-card-title class="theme">
              <span class="headline white--text"
                >Add and invite new employee</span
              >
              <v-spacer />
              <v-btn icon @click="add_entity_dialog = false">
                <v-icon class="white--text">close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pa-0">
              <template>
                <v-stepper v-model="e1">
                  <v-stepper-header class="elevation-0">
                    <v-stepper-step :complete="e1 > 1" step="1" color="theme"
                      >Basic information</v-stepper-step
                    >
                    <v-divider />
                    <v-stepper-step :complete="e1 > 2" step="2" color="theme"
                      >Work information</v-stepper-step
                    >
                    <v-divider />
                    <v-stepper-step :complete="e1 > 3" step="3" color="theme"
                      >On boarding</v-stepper-step
                    >
                    <v-divider />
                    <v-stepper-step :complete="e1 > 4" step="4" color="theme"
                      >Verify</v-stepper-step
                    >
                  </v-stepper-header>
                  <v-divider />
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-card flat>
                        <v-card-text class="pt-0">
                          <v-form ref="form" valid="validation">
                            <v-text-field
                              label="Employee company email*"
                              clearable
                              placeholder="Example: employee@company.com"
                              v-model="work_email"
                              persistent-hint
                              :rules="[
                                validationRules.required,
                                validationRules.email,
                              ]"
                              tabindex="1"
                              :autofocus="true"
                            >
                              <template v-slot:append-outer>
                                <v-tooltip left color="theme">
                                  <template v-slot:activator="{ on }">
                                    <v-icon
                                      small
                                      class="grey--text pt-1"
                                      v-on="on"
                                      >help</v-icon
                                    >
                                  </template>
                                  <div class="text-right">
                                    Please make sure that you invite employees
                                    by using their official email-ids. <br />
                                    It will not be possible to change this at a
                                    later point. <br />
                                  </div>
                                </v-tooltip>
                              </template>
                            </v-text-field>

                            <v-text-field
                              label="First name *"
                              clearable
                              placeholder="Example: John"
                              persistent-hint
                              v-model="firstName"
                              :rules="[validationRules.required]"
                              tabindex="2"
                            />

                            <v-text-field
                              label="Last name"
                              clearable
                              placeholder="Example: Doe"
                              persistent-hint
                              v-model="lastName"
                              tabindex="3"
                            />
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer />
                          <v-btn
                            color="action rounded-sm white--text ml-1"
                            tabindex="4"
                            depressed
                            @click="validateForm"
                            >Continue
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                      <v-card flat>
                        <v-card-text class="pt-0">
                          <v-form ref="workInfoForm" valid="validation">
                            <v-text-field
                              label="Job Title*"
                              clearable
                              placeholder="Example: Software Engineer"
                              v-model="job_title"
                              :rules="[validationRules.required]"
                              tabindex="1"
                              :autofocus="true"
                            />
                            <v-autocomplete
                              class="my-3"
                              placeholder="Example: Oslo"
                              label="Work location*"
                              persistent-hint
                              :items="countries"
                              item-text="name"
                              item-value="name"
                              v-model="location"
                              tabindex="2"
                              :rules="[validationRules.required]"
                            />
                            <v-select
                              class="my-2"
                              placeholder="Example: Accounts"
                              :items="departments"
                              v-model="department"
                              label="Department"
                              item-text="name"
                              tabindex="5"
                              item-value="name"
                            />

                            <v-select
                              class="my-3"
                              :items="employmentTypes"
                              persistent-hint
                              v-model="employmentType"
                              label="Employment type"
                              tabindex="6"
                              placeholder="Example: Permanent"
                            />
                            <v-dialog
                              ref="dialog"
                              v-model="startDateModal"
                              :return-value.sync="startDate"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  persistent-hint
                                  label="Job start date*"
                                  :rules="[validationRules.required]"
                                  v-model="computedStartDateFormatted"
                                  readonly
                                  placeholder="Example: 31-12-2020"
                                  v-on="on"
                                />
                              </template>
                              <v-date-picker
                                v-model="startDate"
                                scrollable
                                class="mt-0 pt-0"
                                :first-day-of-week="1"
                              >
                                <v-btn
                                  text
                                  class="theme-text"
                                  @click="startDateModal = false"
                                  >Cancel
                                </v-btn>
                                <v-spacer />
                                <v-btn
                                  text
                                  class="theme-text"
                                  @click="$refs.dialog.save(startDate)"
                                  >OK
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>

                            <v-text-field
                              class="my-3"
                              label="Employment percentage"
                              persistent-hint
                              placeholder="Example: 100"
                              hint="100% = full time employee"
                              v-model.number="percentageEmployed"
                              type="number"
                              suffix="%"
                              tabindex="7"
                            />

                            <v-autocomplete
                              class="my-3"
                              label="Manager*"
                              :rules="[validationRules.required]"
                              persistent-hint
                              hint="Reporting manager for the employee"
                              :items="managers"
                              :item-text="managerFirstName"
                              v-model="manager"
                              return-object
                              tabindex="8"
                              placeholder="Example: Frank Davis"
                            />
                            <v-text-field
                              class="my-3"
                              label="Salary"
                              persistent-hint
                              placeholder="Example: 30000"
                              :mask="masks.salary"
                              hint="Annual salary of the employee"
                              v-model="salary"
                              tabindex="9"
                            />
                            <v-select
                              class="my-3"
                              :items="payFrequencies"
                              hint="Monthly/ Biweekly/ Annual"
                              v-model="payFrequency"
                              persistent-hint
                              placeholder="Example: Monthly"
                              label="Payment Frequency"
                              tabindex="10"
                            />
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text @click="e1 = 1">back</v-btn>
                          <v-spacer />
                          <v-btn
                            color="action rounded-sm white--text ml-1"
                            tabindex="4"
                            depressed
                            @click="validateWorkForm"
                            >Continue
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-card flat>
                        <v-card-text class="pt-0">
                          <template
                            v-if="
                              workflows &&
                              workflows.length > 0 &&
                              workflows[0].tasks
                            "
                          >
                            <div class="mb-7">
                              Choose if you want to trigger an onboarding
                              workflow and who should be assigned the onboarding
                              tasks
                            </div>
                            <div class="mt-5">
                              <v-row>
                                <v-col cols="4">
                                  <v-checkbox
                                    v-for="item in workflows"
                                    :key="item.id"
                                    v-model="wfs"
                                    :label="item.name"
                                    :value="item"
                                    class="mt-n4"
                                    :persistent-hint="true"
                                  />
                                </v-col>
                                <v-col cols="8" class="text-right pt-1">
                                  <v-btn
                                    small
                                    class="action rounded-sm white--text"
                                    depressed
                                    :disabled="wfs.length === 0"
                                    @click="editTaskOwner = !editTaskOwner"
                                  >
                                    Edit task owners
                                  </v-btn>
                                </v-col>
                              </v-row>

                              <v-simple-table
                                class="border-gray"
                                v-if="
                                  editTaskOwner &&
                                  workflows &&
                                  workflows[0].tasks
                                "
                              >
                                <thead class="theme">
                                  <tr>
                                    <th
                                      class="text-left white--text pl-3 body-1"
                                    >
                                      Name
                                    </th>
                                    <th
                                      class="text-right white--text pr-3 body-1"
                                    >
                                      Assigned To
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="item in workflows[0].tasks"
                                    :key="item.name"
                                  >
                                    <td class="pb-0 pl-3">{{ item.name }}</td>
                                    <td class="py-0 mt-0" style="width: 60%">
                                      <div class="mt-1 mb-n5">
                                        <v-select
                                          v-if="activeEmployees"
                                          :items="activeEmployees"
                                          :item-text="managerFirstName"
                                          item-value="id"
                                          v-model="item.assigned_to_id"
                                          dense
                                          outlined
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-simple-table>
                            </div>
                          </template>
                          <div v-else>
                            You have not created any workflows yet. You can
                            start by creating new workflows
                            <a href="/#/company/workflows" class="theme-text"
                              >here</a
                            >
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn text @click="e1 = 2">back</v-btn>
                          <v-spacer />
                          <v-btn
                            depressed
                            color="action white--text rounded-sm"
                            @click="validateWorkflow"
                            >Continue
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>

                    <v-stepper-content step="4">
                      <v-list subheader three-line>
                        <v-subheader class="ml-n3">
                          <div class="grey--text text--darken-3 mb-3">
                            Check if the info is correct and send an invitation
                            to the employee to join and complete his personal
                            profile.
                          </div>
                        </v-subheader>

                        <v-list-item class="ml-n3">
                          <v-list-item-content>
                            <v-list-item-title>Basic info</v-list-item-title>
                            <v-list-item-subtitle
                              class="my-2 font-weight-normal"
                              >Name: {{ firstName }}
                              {{ lastName }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                              >Email: {{ work_email }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                        <v-list-item class="ml-n3">
                          <v-list-item-content>
                            <v-list-item-title>Work info</v-list-item-title>
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              >JobTitle: {{ job_title }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              v-if="location"
                              >Work location:
                              {{ location }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              v-if="department"
                              >Department:
                              {{ department }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              v-if="employmentType"
                              >Employment Type:
                              {{ employmentType }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              v-if="startDate"
                              >Start date: {{ startDate }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              v-if="percentageEmployed"
                              >Employment percentage:
                              {{ percentageEmployed }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal text-capitalize"
                            >
                              Manager: {{ manager.first_name }}
                              {{ manager.last_name }}
                            </v-list-item-subtitle>
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              v-if="salary"
                              >Salary: {{ salary }}</v-list-item-subtitle
                            >
                            <v-list-item-subtitle
                              class="mt-2 font-weight-normal"
                              v-if="payFrequency"
                              >Payment frequency:
                              {{ payFrequency }}</v-list-item-subtitle
                            >
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />

                        <v-list-item class="mt-n1 ml-n3">
                          <v-list-item-content>
                            <v-list-item-title
                              >Onboarding settings
                            </v-list-item-title>
                            <div v-if="wfs.length > 0 && workflows.length > 0">
                              <v-list-item-subtitle
                                :key="i"
                                class="my-2"
                                v-for="(item, i) in workflows[0].tasks"
                              >
                                {{ item.description }}
                                <div class="mt-1">
                                  <span class="theme-text">Assigned to:</span>
                                  <span class="ml-2">{{
                                    getEmployeeName(item.assigned_to_id)
                                  }}</span>
                                </div>
                              </v-list-item-subtitle>
                            </div>
                            <div v-else>
                              <v-list-item-subtitle
                                >No workflow selected
                              </v-list-item-subtitle>
                            </div>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider />

                        <v-switch
                          v-model="inviteEmployee"
                          class="ml-3"
                          label="Send invitation email to employee"
                        />
                        <div class="mb-2 ml-3 grey--text mt-n4">
                          You can send invites at a later point in time from
                          employee's profile
                        </div>
                        <v-divider />

                        <v-row>
                          <v-col cols="12" class="mt-4">
                            <v-btn text @click="e1 = 3">back</v-btn>
                            <v-btn
                              depressed
                              style="float: right"
                              color="save white--text rounded-sm "
                              @click="saveTheEmployee"
                              >Add Employee
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-list>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </template>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-row>
</template>
<script>
import libphonenumber from "google-libphonenumber";
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";
import { TableHeaders } from "@/views/headers";

export default {
  name: Component.Protected.Employee.Base,
  data() {
    return {
      editTaskOwner: false,
      e1: 1,
      pagination: { disableNext: true, page: 0 },

      // other
      phoneValidator: null,
      snackbar: false,
      snackbarMessage: "",
      breadcrumbs: Breadcrumbs.Employee.Base,
      tableHeaders: TableHeaders.Employee.List,
      onboardingTableHeaders: [
        { text: "Name", value: "name" },
        { text: "Assigned to", value: "assigned_to_id" },
      ],
      employee: null,
      employees: [],
      companyActive: false,

      add_entity_dialog: false,
      add_entity_dialog2: false,
      validation: true,
      types: [],

      // emp details
      firstName: "",
      lastName: "",
      work_email: "",
      type: "",
      id: "",
      is_hr: false,
      is_manager: false,
      is_employee: false,
      job_title: "",
      department: null,
      employmentType: null,
      manager: {},
      startDateModal: false,
      startDate: "",
      payFrequencies: Constants.Employee.PaymentFrequencies.All,
      payFrequency: null,
      salary: null,
      percentageEmployed: null,
      // workPhoneNum: null,
      // workPhoneISD: null,
      location: null,
      locations: [],

      // setup related info
      employmentTypes: [],
      departments: [],

      // company details
      status: "",
      completeInfo: true,
      search: {
        limit: 10,
        type: "",
        job_location: "",
        department: "",
        offset: 0,
      },
      wfs: [],
      managers: [],
      inviteEmployee: true,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "companyInfo", "countries", "workflows"]),
    activeEmployees() {
      return this.employees.filter((e) => e.type === "Active");
    },
    computedStartDateFormatted() {
      return this.datePickerFormat(this.startDate);
    },
    canOnboardEmployees() {
      return (
        this.userInfo.role === Constants.Roles.HR && this.companyInfo.membership
      );
    },
    isDemo() {
      return this.userInfo.role === Constants.Roles.HR && !this.companyActive;
    },
  },
  watch: {
    companyInfo(newValue, oldValue) {
      if (newValue.membership === "Standard") {
        this.setup();
      }
    },
  },
  methods: {
    invitationStatus(item) {
      if (item && item.invited && item.invited === true) {
        return "Invitation sent";
      }
      return "Invitation pending";
    },
    isdCodeName(country) {
      if (country) {
        return `${country.dial_code} - ${country.name}`;
      }
    },
    validateWorkForm() {
      if (this.$refs.workInfoForm.validate()) {
        this.e1 = 3;
      }
    },
    getEmployeeName(id) {
      if (this.employees) {
        let ee = this.employees.filter((e) => {
          if (e.id === id) {
            return e;
          }
        });
        return this.managerFirstName(ee[0]);
      }
      return "";
    },

    validateWorkflow() {
      this.e1 = 4;
    },

    saveTheEmployee() {
      // validate the information
      const empType =
        this.status !== Constants.Company.Status.Registered
          ? Constants.Employee.Type.Registered
          : Constants.Employee.Type.Demo;
      let workflowId = ""; //(this.workflows && this.workflows[0]) ? this.workflows[0].id : '';
      let tasks = [];
      if (
        this.wfs.length > 0 &&
        this.workflows &&
        this.workflows[0] &&
        this.workflows[0].tasks &&
        this.workflows[0].tasks.length > 0
      ) {
        tasks = this.workflows[0].tasks.map((e) => {
          return {
            description: e.description,
            name: e.name,
            assigned_to_id: e.assigned_to_id,
          };
        });
        workflowId = this.workflows[0].id;
      }

      let data = {
        first_name: this.firstName,
        last_name: this.lastName,
        work_email: this.work_email,
        is_employee: true,
        type: empType,
        workflow_id: `${workflowId}`,
        tasks: tasks,
        manager: `${this.manager.first_name} ${this.manager.last_name}`,
        manager_id: this.manager.id,
        job_title: this.job_title,
        employment_type: this.employmentType,
        department: this.department,
        pay_frequency: this.payFrequency,
        salary: parseFloat(this.salary),
        percentage_employed: parseInt(this.percentageEmployed),
        start_date: this.computedStartDateFormatted
          ? this.computedStartDateFormatted
          : null,
        job_location: this.location,
      };

      this.$store
        .dispatch(Actions.Employee.Add, data)
        .then((r) => {
          if (r.status === 200) {
            let payload = {
              id: r.data.id,
              email: this.work_email,
              companyID: this.userInfo.companyID,
              namespace: this.userInfo.namespace,
            };
            // only if the company is registered for some membership
            if (this.inviteEmployee && !this.isDemo) {
              this.$store
                .dispatch(Actions.SendInvite, payload)
                .then((r) => {
                  if (r.status === 200) {
                    this.snackbar = true;
                    this.snackbarMessage = payload.email
                      ? `Activation email sent to ${payload.email}`
                      : "Activation email sent";
                  }
                })
                .catch((e) => {
                  console.error(e);
                  this.snackbar = true;
                  this.snackbarMessage = payload.email
                    ? `Could not send activation email to ${payload.email}`
                    : "Could not send activation email";
                })
                .finally(() => {
                  this.getCompanyStatus();
                });
            }
          } else if (r.status === 400) {
            console.error(Constants.Employee.Messages.Error.Add, err);
            this.snackbar = true;
            this.snackbarMessage = Constants.Employee.Messages.Error.Add;
          }
        })
        .catch((err) => {
          console.error(Constants.Employee.Messages.Error.Add, err);
          this.snackbar = true;
          if (err.data && err.data.message) {
            this.snackbarMessage = err.data.message;
          } else this.snackbarMessage = Constants.Employee.Messages.Error.Add;
        })
        .finally(() => {
          this.closeForm();
          this.getCompanyStatus();
          this.getEmployees();
        });
    },

    managerFirstName(e) {
      if (e) {
        return `${e.first_name} ${e.last_name}`;
      }
      return "";
    },

    resetEmployee() {
      this.work_email = "";
      this.firstName = "";
      this.lastName = "";
      this.phone = "";
      this.type = "";
      this.id = "";
      this.is_hr = false;
      this.is_manager = false;
      this.is_employee = false;
      this.department = "";
      this.inviteEmployee = true;
      this.employmentType = "";
      this.manager = {};
      this.job_title = "";
      // this.workPhoneNum = "";
      // this.workPhoneISD = "";
      this.salary = null;
      this.location = "";
      this.percentageEmployed = null;
      this.payFrequency = "";
      this.startDate = "";
      this.completeInfo = false;
    },
    resetModels() {
      this.employees = null;
      this.employee = null;
      this.add_entity_dialog = false;
      this.wfs = [];
      this.resetEmployee();
    },
    getCompanyStatus() {
      this.$store
        .dispatch(Actions.Auth.Status)
        .then((r) => {
          this.status = r.data.status;
          if (r.status === 200 && r.data) {
            if (r.data.depts && r.data.depts === "OK") {
              this.completeInfo = true;
            }
            if (r.data.status === Constants.Company.Status.Registered) {
              // if the company status is Registered that means they still have Demo employees
              this.sendAlert(true, "theme", null, Constants.Company.Status.Registered);
              //this.sendAlert(true, "theme", null, Constants.Employee.Type.Demo);
              
              this.search = {
                is_employee: "true",
                type: Constants.Employee.Type.Demo,
                limit: 10,
                offset: 0,
              };
            } else if (r.data.status === Constants.Company.Status.Active) {
              this.search = {
                limit: 10,
                offset: 0,
                type: Constants.Employee.Type.Active,
              };

              this.companyActive = true;
            }
            this.getEmployees();
          }
        })
        .catch((err) => {
          console.error(Constants.Auth.Messages.Error.Check, err);
          this.snackbar = true;
          this.snackbarMessage = Constants.Auth.Messages.Error.Check;
        });
    },
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.employees.length <= this.search.limit) {
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getEmployees();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.search.offset = this.search.limit * this.pagination.page;
        this.getEmployees();
      }
    },
    getEmployees() {
      if (!this.search) return false;
      this.$store
        .dispatch(Actions.Employee.Find, this.search)
        .then((r) => {
          if (r.status === 200) {
            let len = r.data.length;
            if ((len < this.search.limit && len > 0) || len === 0) {
              this.pagination.disableNext = true;
            } else if (len === this.search.limit) {
              this.pagination.disableNext = false;
            }
            this.employees = r.data;
          }
        })
        .catch((err) => {
          console.error(Constants.Employee.Messages.Error.Find, err);
          this.snackbarMessage = Constants.Employee.Messages.Error.Find;
          this.snackbar = true;
        });
    },
    viewEntityDetails(item) {
      if (!item) {
        return false;
      }
      this.$router.push({
        name: Component.Protected.Employee.Profile,
        params: { id: item.id },
      });
    },
    updateEntity(item) {
      if (this.userInfo.role !== Constants.Roles.HR || !item) return false;
      this.$router.push({
        name: Component.Protected.Employee.Edit,
        params: { id: item.id },
      });
    },
    sendAlert(show, type, message, component) {
      this.$emit(Constants.Events.Alert, { show, type, message, component });
    },
    openForm() {
      if (this.userInfo.role !== Constants.Roles.HR) return false;
      this.resetEmployee();
      this.add_entity_dialog = true;
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (this.$refs.workInfoForm) this.$refs.workInfoForm.resetValidation();
    },
    closeForm() {
      this.resetEmployee();
      this.add_entity_dialog = false;
      this.e1 = 1;
    },
    validateForm() {
      if (this.$refs.form.validate()) {
        this.e1 = 2;
      }
    },
    saveEntity() {
      if (this.userInfo.role === Constants.Roles.HR) {
        if (this.$refs.form.validate()) {
          this.add_entity_dialog = false;
          const empType =
            this.status !== Constants.Company.Status.Registered
              ? Constants.Employee.Type.Registered
              : Constants.Employee.Type.Demo;

          let wfs = this.wfs.map((e) => e.id);

          let data = {
            first_name: this.firstName,
            last_name: this.lastName,
            work_email: this.work_email,
            is_employee: true,
            type: empType,
            workflows: wfs.toString(),
          };
          this.$store
            .dispatch(Actions.Employee.Add, data)
            .then((r) => {
              if (r.status === 200) {
                this.snackbar = true;
                this.snackbarMessage =
                  Constants.Employee.Messages.Info.StartOnBoarding;
              }
            })
            .catch((err) => {
              console.error(Constants.Employee.Messages.Error.Add, err);
              this.snackbar = true;
              this.snackbarMessage = Constants.Employee.Messages.Error.Add;
            })
            .finally(() => this.getCompanyStatus());
        }
      } else {
        console.log("some error");
      }
    },
    getWorkflows() {
      this.$store.dispatch(Actions.Workflow.Find, {
        limit: 20,
        offset: 0,
        type: "OnBoarding",
      });
    },
    getInfo() {
      this.$store
        .dispatch(Actions.Employee.Info)
        .then((r) => {
          if (r.status === 200 && r.data) {
            this.employmentTypes = r.data.employment_types;
            this.departments = r.data.departments;
            this.managers = r.data.managers;
            this.locations = r.data.locations;
            this.companyActive
              ? (this.types = r.data.types.filter((type) => type !== "Demo"))
              : (this.types = r.data.types);
          }
        })
        .catch(() => {
          this.snackbarMessage = "Could not get additional info";
          this.snackbar = true;
          this.employmentTypes = Constants.Employee.EmploymentType.All;
          this.departments = [];
          this.types = Constants.Employee.Type.All;
        });
    },
    setup() {
      this.resetModels();
      this.getInfo();
      this.phoneValidator = libphonenumber.PhoneNumberUtil.getInstance();
      this.getCompanyStatus();
      this.getWorkflows();
    },
  },
  created() {
    if (this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.CompanyInfo);
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>
<style scoped>
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}
.border-gray {
  border: lightgray solid 1px;
}

.subtext {
  color: #62636b;
  font-size: small;
}

.tabletext {
  font-size: x-large;
}
.disabled {
  background-color: #c6c6c6 !important;
  color: #62636b !important;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
}
</style>